import React from "react";
import { connect } from "react-redux";
import { RootState } from "../redux/rootReducer";
import { DisplayHelpPanel } from "./helpPanelSlice";
import PermissionsPageHelpPanelContent from "../permissions/PermissionsPageHelpPanel";
import TeamsPageHelpPanelContent from "../details/TeamDetailsPageHelpPanel";
import InheritedAccessHelpPanelContent from "../createTeam/inheritedAccess/inheritedAccessHelpPanel";
import { HelpPanel } from "@amzn/awsui-components-react-v3";

interface StateProps {
  display: DisplayHelpPanel | undefined;
}

const HelpPanelMenu: React.FC<StateProps> = ({ display }): JSX.Element => {
  const renderContent = (): JSX.Element | null => {
    if (!display) return null;

    switch (display.contentType) {
      case "permissions":
        return <PermissionsPageHelpPanelContent />;
      case "teamDetails":
        return <TeamsPageHelpPanelContent />;
      case "inheritedAccess":
        return <InheritedAccessHelpPanelContent />;
      case "test":
        return display.customContent ? (
          <div>{display.customContent}</div>
        ) : null;
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      {display && (
        <HelpPanel
          header={display.header}
          footer={display.footer && <>{display.footer}</>}
        >
          {renderContent()}
        </HelpPanel>
      )}
    </React.Fragment>
  );
};

const mapStateToProperties = ({ helpPanel }: RootState): StateProps => {
  return {
    display: helpPanel.displayHelpPanel,
  };
};

export default connect(mapStateToProperties)(HelpPanelMenu);
